import React from 'react';


const Cards = () => {
  return (

    <div class="container">
<br></br>      <div class="row">
        <div class="col-sm">
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button videos frecuentes collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOneinstalacion" aria-expanded="false" aria-controls="flush-collapseOneinstalacion">
                  Instalación del aplicativo
                </button>
              </h2>
              <div id="flush-collapseOneinstalacion" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  <ul>
                    <li class="pregunta">
                      ¿Qué requisitos debe tener el equipo donde voy a instalar el aplicativo?
                    </li>
                    <ul>
                      <li>
                        Computador de escritorio/portátil/tableta.
                      </li>
                      <li>
                        Sistema operativo: Windows 7-10. Android 5-11
                      </li>
                      <li>
                        Cámara web, micrófono
                      </li>
                    </ul>
                    <br />

                    <li class="pregunta">
                      ¿Qué debo hacer si el equipo que voy a utilizar para la evaluación es una MAC y tiene sistema operativo IOS (Apple)?
                    </li>
                    <ul>
                      <li>
                        Debes seguir el tutorial, en el cual te permitirá instalar el S.O. Windows y posteriormente el aplicativo de evaluaciones. Para el tutorial e instalación debes ingresar al <a href="https://www.utpl.edu.ec/evaluaciones">enlace</a>
                      </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Es necesario realizar un mantenimiento al equipo que utilizaré para la evaluación?
                    </li>
                    <ul>
                      <li>
                      Es importante que el equipo cuente con todas las actualizaciones del sistema operativo y que su funcionamiento sea el correcto. Si tienes problemas en la instalación del aplicativo realiza el mantenimiento respectivo.                      </li>
                      </ul>
                  </ul>

                </div>
              </div>
            </div>
            <br/>


          </div>
        </div>
        <div class="col-sm">
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button videos frecuentes collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                Utilización del aplicativo
                </button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">

                <ul>
                    <li class="pregunta">
                    ¿Cómo debo ingresar a la evaluación?
                    </li>
                    <ul>
                      <li>
                      Paso 1: Abre el aplicativo de evaluación
                      </li>
                      <li>
                      Paso 2: Selecciona abrir zoom para ingresar a la sala de evaluación
                      </li>
                      <li>
                      Paso 3: Ingresa tus credenciales del correo de UTPL.
                      </li>
                      <li>
                      Paso 4: El evaluador gestionará el inicio de tus evaluaciones
                      </li>
                    </ul>
                    <br />

                    <li class="pregunta">
                    ¿Qué usuario y contraseña necesito para ingresar a la sala de zoom?
                    </li>
                    <ul>
                      <li>
                      Debes iniciar sesión ingresando tu usuario con el formato usuario@utpl.edu.ec y luego la contraseña correspondiente.
                      </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Con qué usuario y contraseña ingreso al aplicativo?
                    </li>
                    <ul>
                      <li>
                      El nombre de usuario y contraseña para tu evaluación serán entregadas por el evaluador el día de tus exámenes.</li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Cómo puedo ingresar a mis evaluaciones?
                    </li>
                    <ul>
                      <li>
                      Debes ir a la parte superior en mis Próximos tests desde ahí podrás acceder a cada una de tus evaluaciones.</li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Puedo regresar a la pregunta anterior en mi evaluación y modificar la repuesta?
                    </li>
                    <ul>
                      <li>
                      Si, se puede avanzar o retroceder en las preguntas con los botones que se encuentran en la parte inferior de la pantalla.</li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Qué pasa si se acaba el tiempo de mi evaluación?
                    </li>
                    <ul>
                      <li>
                      Ya no puedes continuar con el test y las respuestas serán grabadas.</li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Qué tiempo tengo para rendir mi evaluación?
                    </li>
                    <ul>
                      <li>
                      El tiempo que se muestra en el cronómetro regresivo en la parte superior.</li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Qué pasa si mi cámara web no funciona?
                    </li>
                    <ul>
                      <li>
                      No te puedes evaluar porque es un requisito para rendir tu evaluación.</li>
                      </ul>
                     
                  </ul>
                </div>
              </div>
            </div>
            
            
          </div>
        </div>
      </div>
      <br/>

      <div class="row">
        <div class="col-sm">
          <div class="accordion accordion-flush" id="accordionFlushExample">
 
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingThree">
              <button class="accordion-button videos frecuentes collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                 Consultas
                </button>
              </h2>
              <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                <ul>
                    <li class="pregunta">
                    ¿Dónde puedo consultar mi horario de evaluaciones?
                    </li>
                    <ul>
                      <li>
                      Accediendo al <a href="https://consultahorarios.utpl.edu.ec/">enlace</a>
                      </li>

                    </ul>
                    <br />

                    <li class="pregunta">
                    ¿Cuándo serán publicadas mis notas?
                    </li>
                    <ul>
                      <li>
                      Serán publicadas de acuerdo al calendario académico.                      </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Cuál es el proceso a seguir para solicitar una recalificación?
                    </li>
                    <ul>
                      <li>
                      Ingresar el trámite por servicios estudiantiles.                        </li>
                      </ul>

                      <br/>
                      <li class="pregunta">
                      ¿Qué pasa si no me presento a las evaluaciones en las fechas establecidas?
                    </li>
                    <ul>
                      <li>
                      Debes realizar el trámite para nueva fecha a través de servicios estudiantiles.                       </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Puedo rendir mi evaluación sin el documento de identidad?
                    </li>
                    <ul>
                      <li>
                      No                        </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Qué pasa si llego atrasado a la evaluación?
                    </li>
                    <ul>
                      <li>
                      Debes realizar trámite de nueva fecha a través de servicios estudiantiles.                       </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Pueden estar personas alrededor mío durante la evaluación?
                    </li>
                    <ul>
                      <li>
                      No está permitido acompañantes                        </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Puedo utilizar calculadora en mi evaluación?
                    </li>
                    <ul>
                      <li>
                      Puedes utilizar calculadora básica si consta su uso dentro de las instrucciones de la evaluación                        </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Puedo utilizar hojas en blanco en mi evaluación?
                    </li>
                    <ul>
                      <li>
                      Puedes utilizar hojas si consta dentro de las instrucciones de la evaluación.                       </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Qué pasa si tengo problemas con el servicio de energía eléctrica?
                    </li>
                    <ul>
                      <li>
                      Debes realizar trámite de nueva fecha a través de servicios estudiantiles adjuntando el debido respaldo.                       </li>
                      </ul>
                      <br/>
                      <li class="pregunta">
                      ¿Qué pasa si tengo problemas con el servicio de internet?
                    </li>
                    <ul>
                      <li>
                      Debes realizar trámite de nueva fecha a través de servicios estudiantiles adjuntando el debido respaldo.                     </li>
                      </ul>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col">
         
        </div>
      </div>
      <br></br>
    </div>
  );
}


export default Cards;